export default __webpack_public_path__ + "static/assets/b4272e27990c29872884bfbf0ddc146b.jpg";